var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 88,
    viewBox: "0 0 77 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3215 0C13.3292 0 10.8809 2.44831 10.8809 5.44069V81.6103C10.8809 84.6027 13.3292 87.051 16.3215 87.051H70.7284C73.7208 87.051 76.1691 84.6027 76.1691 81.6103V21.7627L54.4063 0H16.3215Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8469 21.7627H76.169L54.4062 0V16.3221C54.4062 19.3144 56.8546 21.7627 59.8469 21.7627Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1697 38.0838L59.8477 21.7617H76.1697V38.0838Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2882 70.7285C65.2882 72.2246 64.0641 73.4488 62.5679 73.4488H2.72034C1.22415 73.4488 0 72.2246 0 70.7285V43.525C0 42.0288 1.22415 40.8047 2.72034 40.8047H62.5679C64.0641 40.8047 65.2882 42.0288 65.2882 43.525V70.7285Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5674 73.4489H10.8809V76.1692H62.5674C64.0636 76.1692 65.2877 74.945 65.2877 73.4489V70.7285C65.2877 72.2247 64.0636 73.4489 62.5674 73.4489Z",
    fill: "#CAD1D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.728 56.792V53.976H17.216C18.304 53.976 18.768 54.52 18.768 55.384C18.768 56.248 18.304 56.792 17.216 56.792H15.728ZM21.552 55.384C21.552 53.32 20.176 51.768 17.424 51.768H12.992V63H15.728V58.968H17.424C20.288 58.968 21.552 57.24 21.552 55.384ZM29.1044 51.768H24.8964V63H29.1044C32.6884 63 34.9924 60.712 34.9924 57.384C34.9924 54.04 32.6884 51.768 29.1044 51.768ZM27.6324 60.632V54.104H28.9284C30.9924 54.104 32.2084 55.32 32.2084 57.384C32.2084 59.448 30.9924 60.632 28.9284 60.632H27.6324ZM38.4414 63H41.1774V58.456H44.6014V56.328H41.1774V53.96H45.7534V51.768H38.4414V63Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ad8fc31320eadb2101915c81b772f81e.svg";
export { ForwardRef as ReactComponent };